export { default, RegistrationStatusEnum } from './RegistrationStatusBadge';
